import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const RequiredTextWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  width: 100%;
  
`

export const RequiredText = styled.p`
  color: red;
  flex: 1;
`

export const RequiredIcon = styled(FontAwesomeIcon)`
  color: red;
  justify-self: center;
  margin: 0 1.2rem;
  text-align: center;
`
